export const TIME_REGEX = /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/

export const URL_REGEX =
  /(http(s)?:\/\/)(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g
